

















import { Component, Prop, Vue } from 'vue-property-decorator'
import linkify from 'linkifyjs/string'

@Component
export default class Table extends Vue {
  @Prop()
  private txt!: string
  private len = 0

  private created() {
    const rows = this.txt
      .split(/\r?\n/)
      .map(s => s.trim())
      .filter(s => !!s)

    rows.forEach(row => {
      const cells = row.split(/[\s|　][\/|／][\s|　]/).map(cell => cell.trim())
      this.len = cells.length > this.len ? cells.length : this.len
    })
  }

  private getRow(): string[] {
    return this.txt
      .split(/\r?\n/)
      .map(s => s.trim())
      .filter(s => !!s)
  }

  private getCell(row: string): string[] {
    return row.split(/[\s|　][\/|／][\s|　]/).map(cell => cell.trim())
  }

  private convertLinkified(str: string): string {
    return linkify(str)
  }
}
